/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum CustomerCategory {
  MCC = "MCC",
  MCE = "MCE",
  MCA = "MCA",
  SAAS = "SAAS",
  LANDING_ZONE = "LANDING_ZONE",
  L1 = "L1",
  CSM = "CSM",
  ONBOARD = "ONBOARD",
  CPS = "CPS",
  MCDB = "MCDB",
  MCO_OPENSHIFT = "MCO_OPENSHIFT",
  MCO_K8S = "MCO_K8S",
  MFO = "MFO",
  MVM = "MVM",
  SAP = "SAP",
}
export enum CustomerCategoryDisplay {
  MCC = "MCC",
  MCE = "MCE",
  MCA = "MCA",
  SAAS = "SaaS",
  LANDING_ZONE = "LANDING_ZONE",
  L1 = "L1",
  CSM = "CSM",
  ONBOARD = "Onboard",
  CPS = "CPS",
  MCDB = "MCDB",
  MCO_OPENSHIFT = "MCO_OpenShift",
  MCO_K8S = "MCO_Kubernetes",
  MFO = "MFO",
  MVM = "MVM",
  SAP = "SAP",
}
